const home = {
  hero: {
    title: 'One Systeme Caisse',
    subtitle: 'بيع بسهولة وكفاءة',
    description: 'حل موحد لإدارة عملك. حول جهازك إلى صندوق نقود احترافي واحصل على جميع بياناتك أينما كنت.',
    cta: 'طلب عرض توضيحي'
  },
  features: {
    title: 'حل متكامل لعملك',
    description: 'اكتشف ميزاتنا المبتكرة المصممة لتبسيط إدارة عملك. واجهة بديهية وأدوات قوية لتحسين مبيعاتك وإنتاجيتك.',
    items: {
      touch: {
        title: '100% باللمس',
        description: 'واجهة تعمل باللمس بالكامل لاستخدام بديهي وسريع. أدر مبيعاتك وعملياتك بلمسة واحدة.'
      },
      tickets: {
        title: 'الفواتير',
        description: 'نظام فواتير سهل الاستخدام لتتبع وإدارة المدفوعات بشكل مبسط.'
      },
      responsive: {
        title: '100% متجاوب',
        description: 'واجهة تتكيف بشكل مثالي مع جميع الشاشات، من الهاتف الذكي إلى الجهاز اللوحي، لتجربة مستخدم مثالية على جميع الأجهزة.'
      },
      barcode: {
        title: 'الباركود',
        description: 'مسح سريع ودقيق للباركود لإدارة فعالة للمخزون والمبيعات. متوافق مع جميع أنواع الباركود القياسية.'
      }
    }
  },
  quickStart: {
    title: 'ابدأ استخدام PWA OS Caisse في دقائق',
    description: 'تتيح لك التثبيت السريع والاستخدام البديهي البدء فورًا. قم بإعداد صندوق النقود الخاص بك، واستيراد منتجاتك، وابدأ البيع بنقرات قليلة.',
    items: {
      easy: 'سهل الاستخدام',
      secure: '100% آمن',
      backup: 'نسخ احتياطي تلقائي'
    }
  },
  businessTypes: {
    title: 'الحل المثالي لجميع أنواع الأعمال',
    types: [
      'مطعم',
      'مقهى',
      'وجبات سريعة',
      'حلويات',
      'أزياء جاهزة',
      'بقالة',
      'العناية والجمال',
      'إلكترونيات',
      'أثاث وديكور',
      'مجوهرات'
    ]
  },
  testimonials: {
    title: 'آراء التجار',
    rating: '4.4',
    reviews: '+3 000 تقييم على متجر Google Play',
    items: [
      {
        title: 'حل متكامل',
        text: 'استخدام PWA OS Caisse يلبي تمامًا احتياجات عملي، مما يتيح لي تحقيق نجاح مستدام وتقدم ملحوظ.'
      },
      {
        title: 'البساطة والكفاءة',
        text: 'الواجهة سهلة الاستخدام والأداء السلس يجعلها حلاً فعالاً لإدارة عملي بكل بساطة.'
      },
      {
        title: 'خيار اقتصادي',
        text: 'قدم الحل الميسور قيمة استثنائية من خلال مساعدتي في تحسين عمليات عملي دون تكلفة باهظة.'
      }
    ]
  }
};

export default home; 